var _defs, _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyTab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#252a41;}.cls-2{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_844343",
    "data-name": "Rectangle 844343",
    className: "cls-1",
    width: 51,
    height: 16,
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.2,12.5H17.8V5.13H15.28V3.93h6.44v1.2H19.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.94,12.5l-.28-.9h0a2.7,2.7,0,0,1-.95.8,2.83,2.83,0,0,1-1.22.22A2,2,0,0,1,23,12.1a2,2,0,0,1-.53-1.46,1.7,1.7,0,0,1,.74-1.51,4.38,4.38,0,0,1,2.27-.56l1.12,0V8.19a1.35,1.35,0,0,0-.29-.93,1.22,1.22,0,0,0-.9-.3,3.43,3.43,0,0,0-1,.14c-.3.1-.59.22-.88.35l-.44-1a4.75,4.75,0,0,1,1.15-.41,5.17,5.17,0,0,1,1.19-.15,2.79,2.79,0,0,1,1.86.54,2.12,2.12,0,0,1,.63,1.69V12.5Zm-2.05-.94a1.69,1.69,0,0,0,1.2-.42A1.53,1.53,0,0,0,26.55,10V9.41l-.84,0a2.72,2.72,0,0,0-1.41.33,1,1,0,0,0-.44.88.89.89,0,0,0,.25.68A1.17,1.17,0,0,0,24.89,11.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.16,5.9A2.26,2.26,0,0,1,35,6.78a3.92,3.92,0,0,1,.68,2.47A4,4,0,0,1,35,11.73a2.3,2.3,0,0,1-1.91.89,2.27,2.27,0,0,1-1.91-.89h-.09l-.25.77h-1V3.38h1.38V5.55c0,.16,0,.4,0,.72s0,.51,0,.6h.06A2.18,2.18,0,0,1,33.16,5.9ZM32.8,7a1.38,1.38,0,0,0-1.2.49,2.87,2.87,0,0,0-.38,1.63v.1A3,3,0,0,0,31.6,11a1.37,1.37,0,0,0,1.22.53,1.23,1.23,0,0,0,1.11-.58,3.06,3.06,0,0,0,.38-1.67C34.31,7.76,33.81,7,32.8,7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyTab);
export default __webpack_public_path__ + "static/media/key_tab.8656df80.svg";
export { ForwardRef as ReactComponent };